import { gql } from "@apollo/client";

export const setContractorAdditionalMutation = gql`mutation SetContractor($id: String!, $offerId: String!, $input: ContractorInput!) {
  setContractor(id: $id, offerId: $offerId, input: $input)
}
`